import { setGlobal, setGlobalAndPersist } from '../global/useGlobal'
import { Coordinator } from '../navigation/coordinator/coordinator'
import { platformConfig } from '../constants/platform'

export const logout = () => {
  platformConfig.isWeb()
    ? setGlobal({ authToken: undefined }).then(() => {
        Coordinator.logout()
      })
    : setGlobalAndPersist({
        authToken: undefined,
      }).then(() => {
        Coordinator.logout()
      })
}
